module.exports = __webpack_public_path__ + "images/back-gray8140c952287f663811e47dba3a3b7f67.svg";